/* Bookmarks Look Inside enlarge.
   Explicit "Larger view" control only. Sample pages stay swipe-only (no tap-to-open).
*/
(function () {
  if (window.__bookmarksLookInsideV2) return;
  window.__bookmarksLookInsideV2 = true;

  function pages() {
    var root = document.querySelector(".bookmarks-official-preview");
    if (!root) return [];
    return Array.prototype.slice.call(root.querySelectorAll("img"));
  }

  var overlay = document.createElement("div");
  overlay.setAttribute("role", "dialog");
  overlay.setAttribute("aria-modal", "true");
  overlay.setAttribute("aria-label", "Look inside, larger view");
  overlay.style.cssText =
    "display:none;position:fixed;inset:0;z-index:2147483646;background:rgba(18,16,14,.94);" +
    "align-items:center;justify-content:center;padding:20px 56px;box-sizing:border-box;cursor:zoom-out;";

  var img = document.createElement("img");
  img.style.cssText =
    "max-width:100%;max-height:calc(100vh - 72px);width:auto;height:auto;display:block;" +
    "box-shadow:0 12px 48px rgba(0,0,0,.45);cursor:zoom-out;background:#fff;";

  var meta = document.createElement("div");
  meta.style.cssText =
    "position:absolute;bottom:16px;left:0;right:0;text-align:center;color:#f4f1ec;" +
    "font:14px/1.4 system-ui,sans-serif;pointer-events:none;";

  var prev = document.createElement("button");
  var next = document.createElement("button");
  function navBtn(el, label, side) {
    el.type = "button";
    el.setAttribute("aria-label", label);
    el.textContent = side === "left" ? "‹" : "›";
    el.style.cssText =
      "position:absolute;top:50%;transform:translateY(-50%);" +
      (side === "left" ? "left:12px;" : "right:12px;") +
      "width:44px;height:44px;border:0;border-radius:22px;background:#f4f1ec;color:#1a1a1a;" +
      "font-size:28px;line-height:44px;cursor:pointer;";
  }
  navBtn(prev, "Previous page", "left");
  navBtn(next, "Next page", "right");
  overlay.appendChild(img);
  overlay.appendChild(meta);
  overlay.appendChild(prev);
  overlay.appendChild(next);
  document.documentElement.appendChild(overlay);

  var index = 0;
  var open = false;

  function list() {
    return pages();
  }

  function render() {
    var all = list();
    if (!all.length) return;
    if (index < 0) index = 0;
    if (index > all.length - 1) index = all.length - 1;
    var src = all[index];
    img.src = src.currentSrc || src.src;
    img.alt = src.alt || "";
    meta.textContent = index + 1 + " / " + all.length + "  ·  click page to close";
    prev.style.visibility = index === 0 ? "hidden" : "visible";
    next.style.visibility = index === all.length - 1 ? "hidden" : "visible";
  }

  function show(i) {
    if (typeof i === "number") index = i;
    if (!list().length) return;
    render();
    overlay.style.display = "flex";
    document.body.style.overflow = "hidden";
    open = true;
  }

  function hide() {
    overlay.style.display = "none";
    img.removeAttribute("src");
    document.body.style.overflow = "";
    open = false;
  }

  document.addEventListener("click", function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest(".bookmarks-li-open")) {
      e.preventDefault();
      if (open) hide();
      else show(0);
    }
  });

  img.addEventListener("click", function (e) {
    e.stopPropagation();
    hide();
  });
  overlay.addEventListener("click", function (e) {
    if (e.target === overlay) hide();
  });
  prev.addEventListener("click", function (e) {
    e.stopPropagation();
    if (index > 0) {
      index -= 1;
      render();
    }
  });
  next.addEventListener("click", function (e) {
    e.stopPropagation();
    var all = list();
    if (index < all.length - 1) {
      index += 1;
      render();
    }
  });
  document.addEventListener("keydown", function (e) {
    if (!open) return;
    if (e.key === "Escape") hide();
    if (e.key === "ArrowLeft" && index > 0) {
      index -= 1;
      render();
    }
    if (e.key === "ArrowRight" && index < list().length - 1) {
      index += 1;
      render();
    }
  });
})();
